import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import filter from 'lodash/filter';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import Button from 'yoda-core-components/lib/components/Button/Button';
import ModalBox from 'yoda-core-components/lib/components/ModalBox/ModalBox';
import List from 'yoda-core-components/lib/components/List/List';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import {
    selectFeatureFlags,
    selectPreferences,
    selectDeviceType,
} from 'yoda-site-components/lib/selectors/ContextSelector';
import productPricingSelector from 'yoda-site-components/lib/selectors/ProductPricingSelector';
import productFinalPriceAfterCoupon from 'yoda-site-components/lib/selectors/ProductFinalPriceSelector';
import CouponDetailsAction from 'yoda-site-components/lib/actions/CouponDetailsAction';
import AnalyticsAction from 'yoda-site-components/lib/actions/AnalyticsAction';

/* istanbul ignore next */
export class FinalPriceAfterCoupon extends Component {
    static propTypes = {
        couponPriceDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        featureFlags: PropTypes.object,
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        couponDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        pricingDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        displayDetailsLink: PropTypes.bool,
        isSticky: PropTypes.bool,
        couponAmount: PropTypes.number,
        fromMiniPDP: PropTypes.bool,
        showPayOnly: PropTypes.bool,
        alphaId: PropTypes.string,
        isBundleLevelPrice: PropTypes.bool,
        isBundlePage: PropTypes.bool,
        isNetLevelPrice: PropTypes.bool,
        deviceType: PropTypes.object,
        preferences: PropTypes.oneOfType([PropTypes.object]),
        buyNowPayLaterEligibleLen: PropTypes.number,
        couponNetLevelPrice: PropTypes.bool,
    };

    static defaultProps = {
        couponPriceDetails: [],
        featureFlags: {},
        actions: {},
        pricingDetails: {},
        couponDetails: null,
        couponAmount: null,
        displayDetailsLink: true,
        isSticky: false,
        fromMiniPDP: false,
        showPayOnly: false,
        alphaId: '',
        isBundleLevelPrice: false,
        isBundlePage: false,
        isNetLevelPrice: false,
        deviceType: {},
        preferences: {},
        buyNowPayLaterEligibleLen: 0,
        couponNetLevelPrice: false,
    };

    state = {
        isModalOpen: false,
    };

    componentWillReceiveProps(nextProps) {
        /* istanbul ignore else  */
        if (!isEqual(nextProps.couponDetails, this.props.couponDetails)) {
            this.getCouponInfo(nextProps.couponDetails);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            !isEqual(nextProps.pricingDetails, this.props.pricingDetails) ||
            isEmpty(this.props.couponPriceDetails) ||
            !isEqual(nextState.isModalOpen, this.state.isModalOpen)
        );
    }

    getCouponInfo = (couponDetails) => {
        let couponDetailsInfo = null;
        const { couponPriceDetails } = this.props;
        /* istanbul ignore else  */
        if (get(couponPriceDetails, 'couponInfo[0].alphaId', false) && couponDetails) {
            couponDetailsInfo = filter(couponDetails, {
                promoCode: couponPriceDetails.couponInfo[0].alphaId,
            });
        }

        if (couponDetailsInfo && couponDetailsInfo.length) {
            this.openModal();
        } else {
            window.open('/m/jcpenney-coupons/N-mpi6e5');
        }
    };

    openCouponDetails = () => {
        if (this.props.couponDetails && this.props.couponDetails.length) {
            this.getCouponInfo(this.props.couponDetails);
        } else {
            this.props.actions.getCouponDetailsAction();
        }
    };

    openModal() {
        this.setState({ isModalOpen: true });
        this.props.actions.openModalAnalytics('final price after coupon');
    }

    closeModal() {
        this.setState({ isModalOpen: false });
    }

    isCouponAmountAvailable = () => {
        const { couponAmount } = this.props;

        return couponAmount;
    };

    showCouponAmount = () => {
        const { couponAmount } = this.props;
        const couponAmt = couponAmount && (couponAmount.toString().split(' - ') || []);

        if (this.isCouponAmountAvailable() && couponAmt.length) {
            return (
                <>
                    ${couponAmt[0]}
                    {couponAmt[1] && ' - $'}
                    {couponAmt[1]}
                </>
            );
        }

        if (couponAmount) {
            return `$${couponAmount}`;
        }
        return null;
    };

    render() {
        const {
            featureFlags: { displayPriceAfterCouponModal = true },
            couponPriceDetails,
            couponDetails,
            isSticky,
            displayDetailsLink,
            showPayOnly,
            couponAmount,
            preferences,
            buyNowPayLaterEligibleLen,
            couponNetLevelPrice,
        } = this.props;

        const alphaId = this.props.alphaId || get(couponPriceDetails, 'couponInfo[0].alphaId', '');
        let couponDetailsInfo = null;
        /* istanbul ignore else  */
        if (alphaId && couponDetails) {
            couponDetailsInfo = filter(couponDetails, { promoCode: alphaId });
        }

        const renderCouponDetailsContent = (dataItem) => {
            const redeemingChannel =
                dataItem.redeemingChannel && dataItem.redeemingChannel === 'all'
                    ? 'ONLINE & IN-STORE'
                    : `${dataItem.redeemingChannel} ONLY`;
            let headLine = '';
            /* istanbul ignore else  */
            if (dataItem.offers && dataItem.offers.length === 1) {
                headLine = (
                    <div>
                        <p> {dataItem.offers[0].headLine} </p>
                        <p> {dataItem.offers[0].bodyCopy} </p>
                    </div>
                );
            } else {
                headLine = (
                    <div>
                        <p> {dataItem.offers[0].headLine} </p>
                        <p> {dataItem.offers[0].bodyCopy} </p>
                        {dataItem.offers[1] && dataItem.offers[1].conjunction ? (
                            <p>
                                <span>{dataItem.offers[1].conjunction} </span>
                            </p>
                        ) : null}
                        <p> {dataItem.offers[1].headLine} </p>
                        <p> {dataItem.offers[1].bodyCopy} </p>
                    </div>
                );
            }

            const offerEndDate = new Date(dataItem.offerEndDate);
            const month = `0${offerEndDate.getMonth() + 1}`.slice(-2);
            const date = `0${offerEndDate.getDate()}`.slice(-2);
            const year = offerEndDate.getFullYear();
            const expiryDate = `${month}/${date}/${year}`;

            const couponValidity = (
                <div>
                    <p>
                        <span> Code: </span> <span> {dataItem.promoCode} </span>
                    </p>
                    <p>
                        <span> Expires: </span> <span> {expiryDate} </span>
                    </p>
                </div>
            );
            return (
                <div>
                    <div data-automation-id="couponDetailsContainer">
                        <div>
                            <p> {redeemingChannel.toUpperCase()} </p>
                            {headLine}
                        </div>
                        <div>{couponValidity}</div>
                    </div>
                    <p> {dataItem.disclaimerTemplate} </p>
                </div>
            );
        };
        const couponAmt = couponAmount && (couponAmount.toString().split(' - ') || []);
        return (
            <div className={dt(['flex', 'text-brand-red'])}>
                {this.isCouponAmountAvailable() && !isSticky && showPayOnly ? (
                    <h2>pay only</h2>
                ) : null}
                <p
                    className={dt(['font-bold', 'text-2xlarge', 'leading-8', 'pr-1'])}
                    data-automation-id="finalPriceAfterCoupon"
                >
                    {this.showCouponAmount()}
                </p>
                <div
                    className={dt([
                        'font-semibold',
                        'italic',
                        'text-sm',
                        'leading-5',
                        'self-center',
                        'pt-[5px]',
                    ])}
                    data-automation-id="finalPriceCouponInfo"
                >
                    {alphaId ? (
                        <span className={dt(['pr-1'])} data-automation-id="coupon-use-code">
                            with code
                        </span>
                    ) : null}
                    {displayDetailsLink && !isSticky && (
                        <span>
                            {displayPriceAfterCouponModal && alphaId && (
                                <Button
                                    buttonType="Link"
                                    className={dt(['sm:!text-sm', 'sm:!text-brand-red'])}
                                    automationId="couponDetails"
                                    onClick={this.openCouponDetails}
                                >
                                    {alphaId}
                                </Button>
                            )}
                        </span>
                    )}
                </div>
                {!isSticky ? (
                    <ModalBox
                        showModal={this.state.isModalOpen}
                        onClose={() => this.closeModal()}
                        defaultHeader
                        automationId="couponDetails-modal"
                        modalBlockTheme=""
                    >
                        <List
                            childRenderer={renderCouponDetailsContent}
                            datasource={couponDetailsInfo}
                            direction="Vertical"
                            automationId="couponDetails-List"
                        />
                    </ModalBox>
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    couponPriceDetails: productFinalPriceAfterCoupon(ownProps.fromMiniPDP)(state),
    featureFlags: selectFeatureFlags(state),
    pricingDetails: productPricingSelector(ownProps.fromMiniPDP)(state),
    couponDetails: state.couponDetails,
    deviceType: selectDeviceType(state),
    preferences: selectPreferences(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ ...CouponDetailsAction, ...AnalyticsAction }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(FinalPriceAfterCoupon);
